export default "__VITE_ASSET__BJ7WRK59__"